import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Account } from '@surface-elements/accounts/domain';
import { Contact } from '@surface-elements/contacts/domain';
import { environment } from '@surface-elements/shared/environments';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountDataService {
  private http = inject(HttpClient);

  private accountsUrl = `${environment.apiUrl}/accounts`;

  getAccounts(): Observable<Account[]> {
    return this.http.get<Account[]>(this.accountsUrl);
  }

  createAccount(payload: Account): Observable<Account> {
    return this.http
      .post<Account>(this.accountsUrl, payload)
      .pipe(catchError((error: string) => throwError(error)));
  }

  deleteAccount(payload: Account): Observable<Account> {
    return this.http
      .delete<Account>(`${this.accountsUrl}/${payload._id}`)
      .pipe(catchError((error: string) => throwError(error)));
  }

  updateAccount(payload: Account, accountId: string): Observable<Account> {
    return this.http.patch<Account>(
      `${this.accountsUrl}/${accountId}`,
      payload
    );
  }

  createAccountContact(
    payload: Contact,
    accountId: string
  ): Observable<Contact> {
    const apiUrl = `${this.accountsUrl}/${accountId}/contacts`;
    return this.http
      .post<Contact>(apiUrl, payload)
      .pipe(catchError((error: string) => throwError(error)));
  }
}
